// dialogService.js
let showDialog;

export function registerDialog(fn) {
  showDialog = fn;
}

export async function confirmC(message, title = "✅ Confirm") {
  return new Promise((resolve) => {
    showDialog({
      message,
      title,
      showCancel: true,
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}

export async function alertC(message, title = "✅ Message") {
  return new Promise((resolve) => {
    showDialog({
      message,
      title,
      showCancel: false,
      onConfirm: () => resolve(),
    });
  });
}
